import Api from "../../../Services/Api";
import React from "react";
import { fetchAsync } from "../../../Services/Utils";
import M from "moment";
import { mapToDDL } from "../../common/mapper";
import SimpleDDL from "../../../modules/SimpleDDL";
import SimpleInput from "../../../modules/SimpleInput";

export const CONFIG = {
  TAB: {
    BELUM_EKSPEDISI: "BELUM_EKSPEDISI",
    SUDAH_EKSPEDISI: "SUDAH_EKSPEDISI",
  },
  TABLE_COLUMN: [
    {
      name: "",
      label: "No",
      options: {
        customBodyRender: (_, tableMeta) => {
          const { page, rowsPerPage } = tableMeta.tableState;
          const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

          return <>{rowNumber}</>;
        },
        sort: false,
      },
    },
    {
      name: "tanggalFakturJual",
      label: "Tanggal FJ",
      options: {
        setCellProps: () => ({
          style: { width: "100px" },
        }),
        sort: false,
      },
    },
    {
      name: "nomorFakturJual",
      label: "No. FJ",
      options: {
        setCellProps: () => ({
          style: { width: "100px" },
        }),
        sort: false,
      },
    },
    {
      name: "dataCustomer",
      label: "Nama Pembeli",
      options: {
        customBodyRender: (val) => <p>{val?.namaPembeli}</p>,
        setCellProps: () => ({
          style: { width: "100px" },
        }),
        sort: false,
      },
    },
    {
      name: "dataVariant",
      label: "Kode Varian",
      options: {
        customBodyRender: (val) => <p>{val?.kodeVariant}</p>,
        setCellProps: () => ({
          style: { width: "100px" },
        }),
        sort: false,
      },
    },
    {
      name: "dataVariant",
      label: "Nama Varian",
      options: {
        customBodyRender: (val) => <p>{val?.namaVariant}</p>,
        setCellProps: () => ({
          style: { width: "200px" },
        }),
        sort: false,
      },
    },
    {
      name: "dataWarna",
      label: "Kode Warna",
      options: {
        customBodyRender: (val) => <p>{val?.kodeWarna}</p>,
        setCellProps: () => ({
          style: { width: "100px" },
        }),
        sort: false,
      },
    },
    {
      name: "dataWarna",
      label: "Nama Warna",
      options: {
        customBodyRender: (val) => <p>{val?.namaWarnaKomersil}</p>,
        setCellProps: () => ({
          style: { width: "100px" },
        }),
        sort: false,
      },
    },
    {
      name: "nomorMesin",
      label: "Nomor Mesin",
      options: {
        sort: false,
      },
    },
    {
      name: "nomorRangka",
      label: "Nomor Rangka",
      options: {
        sort: false,
      },
    },
    {
      name: "statusEkspedisi",
      label: "Status",
      options: {
        sort: false,
      },
    },
  ],
};

export const CONFIG_DETAIL = {
  TAB: {
    KSU: "KSU",
    Hadiah: "Hadiah",
    OtherItem: "OtherItem",
    Part: "Part",
    Supir: "Supir",
    Foto: "Foto",
  },
  TABLE_COLUMN: (
    tab,
    type,
    handleValueChange,
    handleSelectChange,
    lists = {},
    isNoQR,
    dataTable,
    dataTableNoQR,
    isAddingRow,
    editingRow,
  ) => {
    return [
      {
        name: "",
        label: "No",
        options: {
          customBodyRender: (_, tableMeta) => {
            const { rowsPerPage } = tableMeta.tableState;
            const rowNumber = 0 * rowsPerPage + tableMeta.rowIndex + 1;
            return <>{rowNumber}</>;
          },
          sort: false,
        },
      },
      ...getTableColumnDetail(
        tab,
        type,
        handleValueChange,
        handleSelectChange,
        lists,
        isNoQR,
        dataTable,
        dataTableNoQR,
        isAddingRow,
        editingRow,
      ),
    ];
  },
  TABLE_COLUMN_ADDITIONAL: (
    tab,
    type,
    handleValueChange,
    editingRow,
    dataTableNoQR,
  ) =>
    getAdditioalTableColumn(
      tab,
      type,
      handleValueChange,
      editingRow,
      dataTableNoQR,
    ),
};

const getAdditioalTableColumn = (
  tab,
  type,
  handleValueChange,
  editingRow,
  currentData,
) => {
  const fieldMap = {
    KSU: { name: "ksuQty", label: "Jumlah", inputId: "input_text_ksuQty_item" },
    Hadiah: {
      name: "giftQty",
      label: "Jumlah",
      inputId: "input_text_giftQty_item",
    },
    OtherItem: {
      name: "otherItemQty",
      label: "Jumlah",
      inputId: "input_text_otherItemQty_item",
    },
    Part: {
      name: "partQty",
      label: "Jumlah",
      inputId: "input_text_partQty_item",
    },
  };

  const field = fieldMap[tab];
  if (!field) return null;

  const checkIsEdit = (rowIndex) => {
    const row = currentData?.[rowIndex];
    const isSaved = row?.action?.saved ?? true;

    let baseEdit = type === "edit" || type === "proses";

    if (type === "proses" && row?.source === "SALES_ORDER") {
      baseEdit = false;
    }

    if (!isSaved) return true;

    if (
      editingRow &&
      editingRow.rowIndex === rowIndex &&
      editingRow.tab === tab
    ) {
      return true;
    }

    return false;
  };

  return {
    name: field.name,
    label: field.label,
    options: {
      customBodyRender: (val, tableMeta) => {
        const isEdit = checkIsEdit(tableMeta.rowIndex);
        return isEdit ? (
          <SimpleInput
            id={field.inputId}
            name={field.name}
            box="onlyNumber"
            containerclassname="margin-bottom-none width width-100px"
            value={val ?? ""}
            onChange={(e) =>
              handleValueChange(
                tableMeta.rowIndex,
                e.target.name,
                e.target.value,
                tab,
                true,
              )
            }
          />
        ) : (
          <p>{val}</p>
        );
      },
      sort: false,
    },
  };
};

const optionMapper = {
  KSU: (d) => ({
    label: `${d.kodeKSU} - ${d.name}`,
    value: d.kodeKSU,
    code: d.kodeKSU,
    name: d.name,
    category: d.categoryDTO?.value || null,
  }),
  Hadiah: (d) => ({
    label: `${d.itemCode} - ${d.itemName}`,
    value: d.itemCode,
    code: d.itemCode,
    name: d.itemName,
    category: d.itemCategoryValue || null,
    stock: d.inStock,
  }),
  OtherItem: (d) => ({
    label: `${d.itemCode} - ${d.itemName}`,
    value: d.itemCode,
    code: d.itemCode,
    name: d.itemName,
    category: d.itemCategoryValue || null,
    stock: d.inStock,
  }),
  Part: (d) => ({
    label: `${d.itemCode} - ${d.itemName}`,
    value: d.itemCode,
    code: d.itemCode,
    name: d.itemName,
    category: d.itemCategoryValue || null,
    stock: d.inStock,
  }),
};

const getTableColumnDetail = (
  tab,
  type,
  handleValueChange,
  handleSelectChange,
  lists = {},
  isNoQR,
  dataTable,
  dataTableNoQR,
  isAddingRow,
  editingRow,
) => {
  const currentData = isNoQR ? dataTableNoQR : dataTable;

  const checkIsEdit = (rowIndex) => {
    const row = currentData?.[rowIndex];
    const isSaved = row?.action?.saved ?? true;

    let baseEdit = type === "edit" || type === "proses";

    if (type === "proses" && row?.source === "SALES_ORDER") {
      baseEdit = false;
    }

    if (!isSaved) return true;

    if (
      editingRow &&
      editingRow.rowIndex === rowIndex &&
      editingRow.tab === tab
    ) {
      return true;
    }

    return false;
  };

  switch (tab) {
    case "KSU":
      return [
        {
          name: "ksuCode",
          label: "Kode KSU",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_ksuCode_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="ksuCode"
                  box="search"
                  menuPosition="fixed"
                  options={(lists.listKSU || []).map(optionMapper.KSU)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(tableMeta.rowIndex, "ksuCode", e, "KSU")
                  }
                />
              );
            },
          },
        },
        {
          name: "ksuName",
          label: "Nama KSU",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_ksuName_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="ksuName"
                  box="search"
                  menuPosition="fixed"
                  options={(lists.listKSU || []).map(optionMapper.KSU)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(tableMeta.rowIndex, "ksuName", e, "KSU")
                  }
                />
              );
            },
          },
        },
        {
          name: "ksuCategory",
          label: "Jenis KSU",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleInput
                  id="input_text_ksuCategory"
                  name="ksuCategory"
                  readOnly
                  containerclassname="margin-bottom-none width width-200px"
                  value={val}
                />
              );
            },
          },
        },
        { name: "ksuBarcode", label: "QR Code", options: { sort: false } },
      ];

    case "Hadiah":
      const listHadiah = lists.listHadiah.filter((i) => i.qr !== isNoQR) || [];
      return [
        {
          name: "giftCode",
          label: "Kode Hadiah",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_kodeHadiah_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="giftCode"
                  box="search"
                  menuPosition="fixed"
                  options={listHadiah.map(optionMapper.Hadiah)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(
                      tableMeta.rowIndex,
                      "giftCode",
                      e,
                      "Hadiah",
                      isNoQR,
                    )
                  }
                />
              );
            },
          },
        },
        {
          name: "giftName",
          label: "Nama Hadiah",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_nameHadiah_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="giftName"
                  box="search"
                  menuPosition="fixed"
                  options={listHadiah.map(optionMapper.Hadiah)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(
                      tableMeta.rowIndex,
                      "giftName",
                      e,
                      "Hadiah",
                      isNoQR,
                    )
                  }
                />
              );
            },
          },
        },
        {
          name: "giftCategory",
          label: "Jenis Hadiah",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleInput
                  id="input_text_categoryHadiah"
                  name="giftCategory"
                  readOnly
                  containerclassname="margin-bottom-none width width-200px"
                  value={val}
                />
              );
            },
          },
        },
        { name: "giftBarcode", label: "QR Code", options: { sort: false } },
      ];

    case "OtherItem":
      const listOtherItem =
        lists.listOtherItem.filter((i) => i.qr !== isNoQR) || [];
      return [
        {
          name: "otherItemCode",
          label: "Kode Barang Lain",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_kodeotheritem_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="otherItemCode"
                  box="search"
                  menuPosition="fixed"
                  options={listOtherItem.map(optionMapper.OtherItem)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(
                      tableMeta.rowIndex,
                      "otherItemCode",
                      e,
                      "OtherItem",
                      isNoQR,
                    )
                  }
                />
              );
            },
          },
        },
        {
          name: "otherItemName",
          label: "Nama Barang Lain",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_nameotheritem_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="otherItemName"
                  box="search"
                  menuPosition="fixed"
                  options={listOtherItem.map(optionMapper.OtherItem)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(
                      tableMeta.rowIndex,
                      "otherItemName",
                      e,
                      "OtherItem",
                      isNoQR,
                    )
                  }
                />
              );
            },
          },
        },
        {
          name: "otherItemCategory",
          label: "Jenis Barang Lain",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleInput
                  id="input_text_categoryotheritem"
                  name="otherItemCategory"
                  readOnly
                  containerclassname="margin-bottom-none width width-200px"
                  value={val}
                />
              );
            },
          },
        },
        {
          name: "otherItemBarcode",
          label: "QR Code",
          options: { sort: false },
        },
      ];

    case "Part":
      const listPart = lists.listPart.filter((i) => i.qr !== isNoQR) || [];
      return [
        {
          name: "partCode",
          label: "Kode Part",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_partCode_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="partCode"
                  box="search"
                  menuPosition="fixed"
                  options={listPart.map(optionMapper.Part)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(
                      tableMeta.rowIndex,
                      "partCode",
                      e,
                      "Part",
                      isNoQR,
                    )
                  }
                />
              );
            },
          },
        },
        {
          name: "partName",
          label: "Nama Part",
          options: {
            sort: false,
            customBodyRender: (val, tableMeta) => {
              const isEdit = checkIsEdit(tableMeta.rowIndex);

              return !isEdit ? (
                <p>{val}</p>
              ) : (
                <SimpleDDL
                  id={`select_options_partName_${tableMeta.rowIndex}`}
                  containerclassname="margin-bottom-none width width-200px"
                  name="partName"
                  box="search"
                  menuPosition="fixed"
                  options={listPart.map(optionMapper.Part)}
                  value={val ? { value: val, label: val } : null}
                  onChange={(e) =>
                    handleSelectChange(
                      tableMeta.rowIndex,
                      "partName",
                      e,
                      "Part",
                      isNoQR,
                    )
                  }
                />
              );
            },
          },
        },
        { name: "partCategory", label: "Jenis Part", options: { sort: false } },
        { name: "partBarcode", label: "QR Code", options: { sort: false } },
      ];
  }
};

export const SERVICE = {
  BELUM_EKSPEDISI: {
    getAll: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").getAllEkspedisi,
        setError,
        "Ekspedisi",
        body,
      );
    },
    getById: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").getDetailEkspedisi,
        setError,
        "Ekspedisi",
        body,
      );
    },
    proses: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").prosesEkspedisi,
        setError,
        "Ekspedisi",
        body,
      );
    },
    refreshExpedition: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").refreshPDIAndExpedition,
        setError,
        "Ekspedisi",
        body,
      );
    },
  },
  SUDAH_EKSPEDISI: {
    getAll: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").getAllEkspedisi,
        setError,
        "Ekspedisi",
        body,
      );
    },
    getById: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").getDetailEkspedisi,
        setError,
        "Ekspedisi",
        body,
      );
    },
    proses: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").prosesEkspedisi,
        setError,
        "Ekspedisi",
        body,
      );
    },
    refreshExpedition: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_TRANSACTION").refreshPDIAndExpedition,
        setError,
        "Ekspedisi",
        body,
      );
    },
  },
  CETAK: {
    BAST_DEALER: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_REPORT").cetakBASTDealer,
        setError,
        "Ekspedisi",
        body,
      );
    },
    BAST_MAIN_DEALER: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_REPORT").cetakBASTMainDealer,
        setError,
        "Ekspedisi",
        body,
      );
    },
    BUKU_SERVICE: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_REPORT").cetakBASTBukuService,
        setError,
        "Ekspedisi",
        body,
      );
    },
    BSTK_HADIAH: async (setError, body) => {
      return fetchAsync(
        Api.create("NAGAMAS_REPORT").cetakBASTTemplate,
        setError,
        "Ekspedisi",
        body,
      );
    },
  },
};

export const STATUS_KEY_MAP = {
  KSU: "ksuStatus",
  Hadiah: "giftStatus",
  OtherItem: "otherItemStatus",
  Part: "partStatus",
};

export const BARCODE_KEY_MAP = {
  KSU: "ksuBarcode",
  Hadiah: "giftBarcode",
  OtherItem: "otherItemBarcode",
  Part: "partBarcode",
};

export const BARCODE_ENCRYPTED_KEY_MAP = {
  KSU: "ksuBarcodeEncrypted",
  Hadiah: "giftBarcodeEncrypted",
  OtherItem: "otherItemBarcodeEncryted",
  Part: "partBarcodeEncrypted",
};

export const CATEGORY_MAP = {
  KSU: "KSU",
  Hadiah: "GIFT",
  OtherItem: "OTHER",
  Part: "PART",
};

export const Kode_KEY_MAP = {
  KSU: "ksuCode",
  Hadiah: "giftCode",
  OtherItem: "otherItemCode",
  Part: "partCode",
};

export const STOCK_KEY_MAP = {
  KSU: "ksuStock",
  Hadiah: "giftStock",
  OtherItem: "otherItemStock",
  Part: "partStock",
};

export const STOCK_LIST_MAP = {
  Hadiah: "listHadiah",
  Part: "listPart",
  OtherItem: "listOtherItem",
  KSU: "listKSU",
};

const hasMenyusul = (table = [], tableNoQR = []) => {
  return [...table, ...tableNoQR].some((item) => item?.menyusul);
};

const hasQR = (table = [], field) => {
    return table.some((item) => item?.[field]);
  };

export const constructPayload = (state, props) => {
  const { dataTable, dataTableNoQR } = state;

  const isContainMenyusul =
    hasMenyusul(dataTable.KSU) ||
    hasMenyusul(dataTable.Hadiah, dataTableNoQR.Hadiah) ||
    hasMenyusul(dataTable.OtherItem, dataTableNoQR.OtherItem) ||
    hasMenyusul(dataTable.Part, dataTableNoQR.Part);

  const isContainQR =
    hasQR(dataTable.KSU, "ksuBarcode") ||
    hasQR(dataTable.Hadiah, "giftBarcode") ||
    hasQR(dataTable.OtherItem, "otherItemBarcode") ||
    hasQR(dataTable.Part, "partBarcode");

  const allRowsCompleted = [
    ...dataTable.KSU.map((i) => !i?.menyusul && i?.ksuBarcode),
    ...dataTable.Hadiah.map((i) => !i?.menyusul && i?.giftBarcode),
    ...dataTable.OtherItem.map((i) => !i?.menyusul && i?.otherItemBarcode),
    ...dataTable.Part.map((i) => !i?.menyusul && i?.partBarcode),
  ].every(Boolean);

  let expeditionStatus;
  if (props.tab === "SUDAH_EKSPEDISI") {
    expeditionStatus = allRowsCompleted ? "SELESAI" : "MENYUSUL";
  } else {
    expeditionStatus = !isContainMenyusul && isContainQR ? "SELESAI" : "MENYUSUL";
  }

  return {
    expeditionNo: state.dataHeader?.expeditionNo,
    expeditionDate: M(new Date()).format("DD-MM-YYYY"),
    pdiNo: state.dataHeader?.pdiNo,
    kodeCabang: state.dataHeader?.kodeCabang?.kodeCabang,
    orderH1: state.dataHeader?.noFakturJual,
    customerId: state.dataHeader?.customerId,
    expeditionStatus: expeditionStatus,
    frameNumber: state.dataHeader?.frameNumber,
    engineNumber: state.dataHeader?.engineNumber,
    deliveryManId: state.dataSupir?.driverName?.value || null,
    expeditionAddressNote: state.dataSupir?.addressNote,
    action: props.actionType.toUpperCase(),
    dataKSU: state.dataTable.KSU.map(
      ({ ksuBarcodeEncrypted, action, source, KSU, ...rest }) => rest,
    ),
    dataGift: {
      dataGiftQR: state.dataTable.Hadiah.map(
        ({ giftBarcodeEncrypted, action, source, GIFT, ...rest }) => rest,
      ),
      dataGiftTanpaQR: state.dataTableNoQR.Hadiah.map(
        ({ id, action, source, GIFT, ...rest }) => rest,
      ),
    },
    dataOtherItem: {
      dataOtherItemQR: state.dataTable.OtherItem.map(
        ({ otherItemBarcodeEncryted, action, source, OTHER, ...rest }) => rest,
      ),
      dataOtherItemTanpaQR: state.dataTableNoQR.OtherItem.map(
        ({ id, action, source, OTHER, ...rest }) => rest,
      ),
    },
    dataPart: {
      dataPartQR: state.dataTable.Part.map(
        ({ partBarcodeEncrypted, action, source, PART, ...rest }) => rest,
      ),
      dataPartTanpaQR: state.dataTableNoQR.Part.map(
        ({ id, action, source, PART, ...rest }) => rest,
      ),
    },
  };
};

export const constructDataDetail = (data) => {
  return {
    dataHeader: {
      kodeCabang: data.cabang,
      pdiNo: data.pdiNo,
      expeditionNo: data.expeditionNo,
      engineNumber: data.engineNumber,
      frameNumber: data.frameNumber,
      noFakturJual: data.noFakturJual,
      tglFakturJual: data.tglFakturJual,
      buyerName: data.dataCustomer?.namaPembeli,
      customerId: data.dataCustomer?.kodeCustomer,
      idKelurahan: data.dataCustomer?.idKelurahan,
      alamat: data.dataCustomer?.alamat,
      tipeUnit: data.tipeUnit,
      warnaUnit: data.warnaUnit,
    },
    dataTable: {
      KSU: data.dataListKSU,
      Hadiah: data.dataListGiftBarcode,
      OtherItem: data.dataListOtherItemBarcode,
      Part: data.dataListPartBarcode,
    },
    dataTableNoQR: {
      KSU: [],
      Hadiah: data.dataListGift,
      OtherItem: data.dataListOtherItem,
      Part: data.dataListPart,
    },
    dataSupir: {
      ...data.dataSupir,
      driverName: mapToDDL(
        data.dataMasterDriver?.driverName,
        data.dataMasterDriver?.driverId,
      ),
      addressNote: data.addressNote,
    },
    dataFoto: data.base64DataFoto,
  };
};

export const constructPayloadCetak = (
  value,
  dataHeader,
  dataCetakanBSTKHadiah,
  username,
) => {
  switch (value?.value) {
    case "BAST_DEALER":
      return {
        fjDate: dataHeader?.tglFakturJual,
        colorType: dataHeader?.warnaUnit,
        frameNumber: dataHeader?.frameNumber,
        engineNumber: dataHeader?.engineNumber,
        name: dataHeader?.buyerName,
        address: dataHeader?.alamat,
        expeditionId: dataHeader?.expeditionNo,
        username: username,
        kodeCabang: dataHeader?.kodeCabang?.kodeCabang,
        idKelurahan: dataHeader.idKelurahan,
      };
    case "BAST_MAIN_DEALER":
      return {
        kodeCabang: dataHeader?.kodeCabang.kodeCabang,
        bast: "BAST_MAIN_DEALER",
        orderH1: dataHeader?.noFakturJual,
        expeditionId: dataHeader?.expeditionNo,
        username: username,
      };
    case "BUKU_SERVICE":
      return {
        kodeCabang: dataHeader?.kodeCabang?.value,
        bast: "BAST_LABEL_SERVICE_BOOK",
        orderH1: dataHeader?.noFakturJual,
        expeditionId: dataHeader?.expeditionNo,
        username: username,
      };
    case "BSTK_HADIAH":
      return {
        ...dataCetakanBSTKHadiah,
        expeditionId: dataHeader?.expeditionNo,
        username: username,
      };
  }
};
